export default {
    alerts: {
        error5xx: {
            id: 'alerts.error5xx'
        },
        error5xxWithRequestId: {
            id: 'alerts.error5xxWithRequestId'
        },
        formError: {
            id: 'alerts.formError'
        },
        genericError: {
            id: 'alerts.genericError'
        },
        websocketError: {
            id: 'alerts.websocketError'
        }
    },
    headers: {
        backToInformation: {
            id: 'headers.backToInformation'
        },
        backToDashboard: {
            id: 'headers.backToDashboard'
        },
        backToPreferences: {
            id: 'headers.backToPreferences'
        },
        help: {
            id: 'headers.help'
        },
        supportHelpCenter: {
            id: 'headers.supportHelpCenter'
        },
        information: {
            id: 'headers.information'
        },
        integrations: {
            id: 'headers.integrations'
        },
        logOut: {
            id: 'headers.logOut'
        },
        organizations: {
            id: 'headers.organizations'
        },
        preferences: {
            id: 'headers.preferences'
        },
        processing: {
            id: 'headers.processing'
        },
        serviceCatalog: {
            id: 'headers.serviceCatalog'
        },
        dashboard: {
            id: 'headers.dashboard'
        },
        personalInformation: {
            id: 'headers.personalInformation'
        },
        basicInformation: {
            id: 'headers.basicInformation'
        },
        language: {
            id: 'headers.language'
        },
        security: {
            id: 'headers.security'
        },
        resetPassword: {
            id: 'headers.resetPassword'
        },
        home: {
            id: 'headers.home'
        },
        offline: {
            id: 'headers.offline'
        },
        selectCountry: {
            id: 'headers.selectCountry'
        }
    },
    buttons: {
        accept: {
            id: 'buttons.accept'
        },
        back: {
            id: 'buttons.back'
        },
        backToApp: {
            id: 'buttons.backToApp'
        },
        cancel: {
            id: 'buttons.cancel'
        },
        close: {
            id: 'buttons.close'
        },
        continue: {
            id: 'buttons.continue'
        },
        create: {
            id: 'buttons.create'
        },
        discard: {
            id: 'buttons.discard'
        },
        discardChanges: {
            id: 'buttons.discardChanges'
        },
        next: {
            id: 'buttons.next'
        },
        reject: {
            id: 'buttons.reject'
        },
        save: {
            id: 'buttons.save'
        },
        saveChanges: {
            id: 'buttons.saveChanges'
        },
        submit: {
            id: 'buttons.submit'
        },
        acceptAllCookies: {
            id: 'buttons.acceptAllCookies'
        },
        tryAgain: {
            id: 'buttons.tryAgain'
        },
        ignore: {
            id: 'buttons.ignore'
        },
        change: {
            id: 'buttons.change'
        },
        chooseCountry: {
            id: 'buttons.chooseCountry'
        },
        ok: {
            id: 'buttons.ok'
        },
        signUp: {
            id: 'buttons.signUp'
        }
    },
    infos: {
        cookieInfo: {
            id: 'infos.cookieInfo'
        },
        disconnectApp: {
            id: 'infos.disconnectApp'
        },
        googleDriveDataTransfer: {
            id: 'infos.googleDriveDataTransfer'
        },
        menuDisabledIfActiveVisit: {
            id: 'infos.menuDisabledIfActiveVisit'
        },
        offline: {
            id: 'infos.offline'
        },
        unsavedChanges: {
            id: 'infos.unsavedChanges'
        },
        selectCountry: {
            id: 'infos.selectCountry'
        }
    },
    labels: {
        country: {
            id: 'labels.country'
        },
        countryCode: {
            id: 'labels.country'
        },
        dateOfBirth: {
            id: 'labels.dateOfBirth'
        },
        phoneNumber: {
            id: 'labels.phoneNumber'
        },
        rowsPerPage: {
            id: 'labels.rowsPerPage'
        },
        yes: {
            id: 'labels.yes'
        },
        no: {
            id: 'labels.no'
        },
        language: {
            id: 'labels.language'
        },
        status: {
            id: 'labels.status'
        },
        step: {
            id: 'labels.step'
        },
        activeStepOfSteps: {
            id: 'labels.activeStepOfSteps'
        },
        day: {
            id: 'labels.day'
        },
        month: {
            id: 'labels.month'
        },
        year: {
            id: 'labels.year'
        }
    },
    links: {
        privacyPolicy: {
            id: 'links.privacyPolicy'
        }
    },
    placeholders: {
        country: {
            id: 'placeholders.country'
        },
        day: {
            id: 'placeholders.day'
        },
        month: {
            id: 'placeholders.month'
        },
        year: {
            id: 'placeholders.year'
        },
        empty: {
            id: 'placeholders.empty'
        },
        selectCountry: {
            id: 'placeholders.selectCountry'
        }
    },
    timeUnits: {
        h: {
            id: 'timeUnits.h'
        },
        m: {
            id: 'timeUnits.m'
        },
        s: {
            id: 'timeUnits.s'
        }
    },
    errorPage: {
        errorCode: {
            id: 'errorPage.errorCode'
        },
        goToHomePage: {
            id: 'errorPage.goToHomePage'
        },
        general: {
            title: {
                id: 'errorPage.general.title'
            },
            info: {
                id: 'errorPage.general.info'
            },
            info2: {
                id: 'errorPage.general.info2'
            }
        },
        notFound: {
            title: {
                id: 'errorPage.notFound.title'
            },
            info: {
                id: 'errorPage.notFound.info'
            }
        }
    },
    errors: {
        MfaLock: {
            id: 'errors.MfaLock'
        },
        businessErrors: {
            InvalidOTP: {
                id: 'errors.businessErrors.InvalidOTP'
            },
            InvalidOTPEntry: {
                id: 'errors.businessErrors.InvalidOTPEntry'
            },
            InvalidOTPEntryLimit: {
                id: 'errors.businessErrors.InvalidOTPEntryLimit'
            },
            InvalidOTPEntryLock: {
                id: 'errors.businessErrors.InvalidOTPEntryLock'
            },
            SignalRError: {
                id: 'errors.businessErrors.SignalRError'
            },
            IdentityInactive: {
                id: 'errors.businessErrors.IdentityInactive'
            }
        }
    },
    toast: {
        header: {
            success: {
                id: 'toast.header.success'
            },
            information: {
                id: 'toast.header.information'
            },
            warning: {
                id: 'toast.header.warning'
            },
            error: {
                id: 'toast.header.error'
            }
        }
    }
};
